/**
 * Environment-gated logging utility
 * Only logs in development mode
 */

const isDevelopment = process.env.NODE_ENV === "development";

export const logger = {
	info: (...args) => {
		if (isDevelopment) {
			console.log(...args);
		}
	},

	error: (...args) => {
		if (isDevelopment) {
			console.error(...args);
		}
	},

	warn: (...args) => {
		if (isDevelopment) {
			console.warn(...args);
		}
	},

	debug: (...args) => {
		if (isDevelopment) {
			console.debug(...args);
		}
	},
};
